import axios from 'axios'
import { ElMessage, ElMessageBox } from 'element-plus'
import router from '@/router';
import { removeCookie, getCookie } from '../assets/js/cookie';
const crypto = require("crypto");


let isShow = false

let url = (process.env.VUE_APP_ENV_NAME === 'dev' || process.env.VUE_APP_ENV_NAME === 'dev-pro') ? process.env.VUE_APP_API_URL : window.location.origin + process.env.VUE_APP_API_URL_PATH
console.log('url', url);

// axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// create an axios instance
const service = axios.create({
  baseURL: url, // url = base url + request url
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 240000 // request timeout
})
// request interceptor
service.interceptors.request.use(
  config => {
    const timestamp = new Date().getTime()
    let signStr = sign(timestamp.toString(), getUuid())
      // config.headers['Authorization'] = 'Bearer3 ' + signStr
    if (getCookie()) {
      config.headers['Token'] = getCookie()
    }
    config.headers['platform'] = 1
    return config
  },
  error => {
    // do something with request error
    return Promise.reject(error)
  }
)

function getUuid () {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
    /[xy]/g,
    function (c) {
      var r = (Math.random() * 16) | 0,
        v = c == 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    }
  );
}

function sign (timestampStr, uuid) {
  // console.log('签名：', timestampStr, uuid)
  let secret = "l8c2scudgvf3aavrkuohep4r6a16nj7s"
  let stringToSign = timestampStr + uuid;
  // console.log('sign', crypto)
  let mac = crypto.createHmac("sha256", secret);
  mac.update(stringToSign);
  let signData = mac.digest();
  let signStr = Buffer.from(signData).toString("base64");
  let stringToSignStr = Buffer.from(stringToSign).toString("base64");
  return signStr + stringToSignStr;
}



function showLogout() {
  // 保存当前路由信息到localStorage，排除登录页
  const currentRoute = router.currentRoute.value;
  console.log(currentRoute.path, currentRoute.query, currentRoute.fullPath);
  removeCookie('yw')
  if (currentRoute.path === '/notice-detail') {
    router.replace({ path: '/login', query: {
      redirectPath: currentRoute.fullPath
    }})
  } else {
    router.replace({ path: '/login' })
  }
  ElMessageBox.confirm('登录状态已过期，请重新登录', '系统提示', {
    confirmButtonText: '确定',
    // cancelButtonText: '取消',
    type: 'warning',
    confirmButtonClass: 'btn-item btn-active',
    showCancelButton: false
    // cancelButtonClass: 'btn-item',
  }).then(() => {
    // router.replace({ path: '/login' })
  }).catch(() => {})
}

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  res => {

    // 未设置状态码则默认成功状态
    const code = res.data.code || 200
    // 获取错误信息
    const msg = res.data.message || '接口异常'
    if (code === 401) {
      if (!isShow) {
        showLogout()
        isShow = true
        setTimeout(()=>{
          if (getCookie() && getCookie() !== 'null' && getCookie() !== null) { 
            isShow = false
          }
        }, 1500)
      }
    } else if (code === 413) {
      // console.log('版权中心token失效');
      return Promise.resolve(res.data)
    } else if (code === 414) {
      // console.log('上传文件失败');
      return Promise.resolve(res.data)
    } else if (code === 415) {
      // console.log('版权人信息不一致');
      return Promise.resolve(res.data)
    } else if (code === 416) {
      // console.log('未实名');
      return Promise.resolve(res.data)
    } else if (code === 417) {
      // console.log('无默认地址');
      return Promise.resolve(res.data)
    } else if (code === 418) { 
      // 418 该权益未扣费，且只有一个可以扣费的套餐；同时返回改套餐的id
      // 419 该权益未扣费，且有多个可以扣费的套餐，调用获取相关套餐的接口，选择套餐
      // 420 该权益未扣费，且用户没有相关可以扣费的套餐，提示用户购买相关套餐
      return Promise.resolve(res.data)
    } else if (code === 419) {
      return Promise.resolve(res.data)
    } else if (code === 420) {
      return Promise.resolve(res.data)
    } else if (code === 421) { //安装包下载中
      return Promise.resolve(res.data)
    } else if (code === 440) { //验证码失败
      return Promise.resolve(res.data)
    } else if (code === 460) { //一键同步失败
      return Promise.resolve(res.data)
    } else if (code === 400) { //400-提示性错误
      return Promise.resolve(res.data)
    } else if (code === 437) { //请输入正确的验证码（短信验证码错误）
      return Promise.resolve(res.data)
    } else if (code === 471) { //存在一个正在处理中的批次
      return Promise.resolve(res.data)
    } else if (code === 472) { //存在一个待确定的批次
      return Promise.resolve(res.data)
    } else if (code === 550) { //登录失败（用户名密码错误）
      return Promise.resolve(res.data)
    } else if (code === 560) { //560-流程错误
      return Promise.resolve(res.data)
    } else if (code === 5404) { //5404-没有审查流程
      return Promise.resolve(res.data)
    } else if (code === 0) { //0-获取登录验证码成功
      return Promise.resolve(res.data)
    } else if (code === 1) { //1-获取待验证用户信息成功
      return Promise.resolve(res.data)
    } else if (code === 2) { //2-获取发送短信验证码成功
      return Promise.resolve(res.data)
    } else if (code === 3) { //3-授权成功
      return Promise.resolve(res.data)
    }else if (code === 500) {
      if (res.request.responseURL.includes('/copyright/loginPre') ||
      res.request.responseURL.includes('/copyright/loginNext')) {
        ElMessage({
          showClose: true,
          message: msg,
          type: 'error',
          duration: 5000
        })
      } else {
        ElMessage.error(msg)
      }
      return Promise.reject(new Error(msg))
    } else if (code !== 200) {     
      // if (!res.request.responseURL.includes('/copyright/addInformation')) {
      ElMessage.error(msg)
      return Promise.reject('error')
    } else {
      return Promise.resolve(res.data)
    }
  },
  error => {
    let href = window.location.href
    if (href.indexOf('stop-service') === -1 && error.response.status === 502) {
      router.push({ path: '/stop-service' })
    }
    return Promise.reject(error)
  }
)

export default service
